import { InfoCircleOutlined, PlusOutlined, EyeOutlined } from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Tooltip,
  message
} from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { fetchBlosterList, resetBlosterList, resetCurrentBlosterPage } from '../../slices/bolster';
import { fetchDiePressList, resetCurrentDiePressPage, resetDiePressList } from '../../slices/die-press';
import { fetchVendorList, resetCurrentVendorPage, resetVendorList } from '../../slices/vendor';
import { resetDieProfileList, fetchDieProfileById } from './../../slices/die-profile';
import { fetchDieSizeList, resetCurrentDieSizePage, resetDieSizeList } from './../../slices/die-size';
import { createProfileDieTool, fetchDieToolDetails } from './../../slices/die-tool';
import { createNumberValidationRule } from '../../utils/CreateNumberValidationRule';

const { Option } = Select;

function AddProfileDieTool() {
  const [form] = Form.useForm();
  let navigate = useNavigate();
  const { id } = useParams();
  const [btnLoading, setBtnLoading] = useState(false);
  const [searchDieSize, setSearchDieSize] = useState('');
  const [searchDeveloper, setSearchDeveloper] = useState('');
  const [searchDiePress, setSearchDiePress] = useState('');
  const [searchGroup, setSearchGroup] = useState('');
  const [searchBloster, setSearchBloster] = useState('');
  const dispatch = useDispatch();
  const [runUnderDeviation, setRunUnderDeviation] = useState('under development');
  const [runUnderDeviationReason, setRunUnderDeviationReason] = useState('');

  const { list: dieSizeList, loading: dieSizeLoading, currentPage: dieSizeCurrentPage, hasMore: dieSizeHasMore } = useSelector((state) => state.diesize);
  const { list: developerList, loading: developerLoading, currentPage: developerCurrentPage, hasMore: developerHasMore } = useSelector((state) => state.vendor);
  const { list: blosterList, loading: blosterLoading, currentPage: blosterCurrentPage, hasMore: blosterHasMore } = useSelector((state) => state.bloster);
  const { list: diePressList, loading: diePressLoading, currentpage: diePressCurrentPage, hasMore: diePressHasMore } = useSelector(state => state.diePress);
  const [isReceivedDateRequired, setIsReceivedDateRequired] = useState(false);
  const [isCheckboxDisabled, setIsCheckboxDisabled] = useState(false);
  const [selectedSolidOption, setSelectedSolidOption] = useState(null);
  const [selectedDieProfile, setSelectedDieProfile] = useState(null);
  const [dieType, setDieType] = useState(null);
  const [selectHollowOption, setSelectHollowOption] = useState(null);
  const [selectSemiHollowOption, setSelectSemiHollowOption] = useState(null);
  const [profileResponse, setProfileResponse] = useState(null);

  const [dieProfileDropdown, setDieProfileDropdown] = useState([]);
  const hollowOptions = [
    { id: 'Full Set', name: 'Full Set' },
    { id: 'Die Plate', name: "Die Plate" },
    { id: 'Mandril', name: 'Mandril' },
  ];
  const semiHollowOptions = [
    { id: 'Die Plate', name: "Die Plate" },
    { id: 'Mandril', name: 'Mandril' }
  ];
  const solidOptions = [
    { id: 'Full Set', name: 'Full Set' },
    { id: 'Die Plate', name: 'Die Plate' },
    { id: 'Insert', name: 'Insert' },
  ];
  const handleSemiHoolowOptionChange = value => {
    setSelectSemiHollowOption(value);

    form.setFieldsValue({
      backer_number: undefined,
      diameter: undefined,
      thickness: undefined,
    });
  };

  const handleSearchHSemiHollowDie = (value) => {
    setSelectSemiHollowOption(value);
  };
  const handleSolidOptionChange = value => {
    setSelectedSolidOption(value);

    form.setFieldsValue({
      backer_number: undefined,
      diameter: undefined,
      thickness: undefined,
    });
  };
  const handleSearchSolidDie = (value) => {
    setSelectedSolidOption(value);
  };
  const handleDeviationChange = (e) => {
    const value = e.target.value;
    setRunUnderDeviation(value);
    if (value !== 'inactive') {
      setRunUnderDeviationReason('');
    }
  };

  const handleHoolowOptionChange = value => {
    setSelectHollowOption(value);

    form.setFieldsValue({
      backer_number: undefined,
      diameter: undefined,
      thickness: undefined,
    });
  };

  const handleSearchHollowDie = (value) => {
    setSelectHollowOption(value);
  };

  const handleReasonChange = (e) => {
    setRunUnderDeviationReason(e.target.value);
  };

  const handleReceivedDateChange = (date, dateString) => {
    form.setFieldsValue({ received_date: date });
  };

  const handleFormChange = (changedValues) => {
    if ('received_date' in changedValues) {
      const orderDate = changedValues.received_date;
      if (orderDate) {
        form.setFieldsValue({ is_active: true });
        setIsCheckboxDisabled(true)
      } else {
        setIsCheckboxDisabled(false);
        form.setFieldsValue({ is_active: false });
      }
    }

    if ('is_active' in changedValues) {
      const isChecked = changedValues.is_active;
      if (isChecked) {
        setIsReceivedDateRequired(true); // Make order_date required
      } else {
        setIsReceivedDateRequired(false); // Remove required validation for order_date
      }
    }
  };

  useEffect(() => {
    const fetchDieProfile = async () => {
      try {
        dispatch(fetchDieProfileById(id))
          .unwrap()
          .then(response => {
            if (response.results.data.length > 0) {
              setDieProfileDropdown(response.results.data[0]);
              form.setFieldsValue({ die: response.results.data[0].id });
              handleDieProfileChange(response.results.data[0].die_number, response.results.data[0].id);
            }
          })
          .catch(error => {
            console.error(error);
          });
      } catch (error) {
        console.error(error);
      }
    };
    fetchDieProfile();
  }, [id]);

  useEffect(() => {
     if (profileResponse !== null) {
      const fetchDieProfile = async () => {
      try {
        dispatch(fetchDieProfileById(id))
          .unwrap()
          .then(response => {
            if (response.results.data.length > 0) {
              setDieProfileDropdown(response.results.data[0]);
              form.setFieldsValue({ die: response.results.data[0].id });
              handleDieProfileChange(response.results.data[0].die_number, response.results.data[0].id);
               setProfileResponse(null);
            }
          })
          .catch(error => {
            console.error(error);
          });
      } catch (error) {
        console.error(error);
      }
    };
    fetchDieProfile();
     }
  }, [profileResponse])


  const handleDieProfileChange = (selected, value) => {
    setSelectedDieProfile(value)
    if (!selected) {
      form.setFieldsValue({
        tool_number: null,
        die_type: null,
        total_running_qty: null,
        total_running_ton: null,
        current_kg: null,
      });
      setSearchGroup(null); // Reset searchGroup state to clear the selected value
      return;
    }
    try {
      dispatch(fetchDieToolDetails(selected))
        .unwrap()
        .then((response) => {
          if (response.success) {

            const fetchedDieType = response.data.die_type;
            setDieType(fetchedDieType);
            form.setFieldsValue({
              tool_number: response.data.tool_number,
              die_type: fetchedDieType,
              total_running_qty: response.data.total_running_qty,
              total_running_ton: response.data.total_running_ton,
              current_kg: response.data.tool_number === "1" ? response.wt_kg_p_mt : 0
            });
          }
        })
        .catch((error) => {
          console.error('');
        });
    } catch (error) {
      console.error('');
    }
  };
  const handleSearchDieGroup = (value) => {
    setSearchGroup(value);
    if (value) {
      dispatch(fetchDieToolDetails({ page: 1, pagesize: 1000, search: value }));
    } else {

      dispatch(fetchDieToolDetails({ page: 1, pagesize: 10 }));

    }
  };
  const onScrollDiePress = async event => {
    const target = event.target;
    if (!diePressLoading && diePressHasMore && target.scrollTop + target.offsetHeight === target.scrollHeight) {
      dispatch(fetchDiePressList({ page: diePressCurrentPage, pagesize: 10 }));
    }
  };


  const handleSearchDieSize = value => {
    setSearchDieSize(value);
    if (value) {
      setSearchDieSize(value);
      dispatch(resetDieSizeList());
      dispatch(fetchDieSizeList({ page: 1, pagesize: 100, search: value }));
    } else {
      setSearchDieSize('');
      dispatch(resetDieSizeList());
      dispatch(resetCurrentDieSizePage());
      dispatch(fetchDieSizeList({ page: 1, pagesize: 10 }));
    }
  };
  const handleChangeDieSize = (value) => {
    setSearchDieSize(value);
  };

  const handleSearchDeveloper = value => {
    setSearchDeveloper(value);
    if (value) {
      setSearchDeveloper(value);
      dispatch(resetVendorList());
      dispatch(fetchVendorList({ page: 1, pagesize: 100, search: value }));
    } else {
      setSearchDeveloper('');
      dispatch(resetVendorList());
      dispatch(resetCurrentVendorPage());
      dispatch(fetchVendorList({ page: 1, pagesize: 10 }));
    }
  };

  const handleChangeDeveloper = (value) => {
    setSearchDeveloper(value);
  };

  const handleSearchBloster = value => {
    setSearchBloster(value);
    if (value) {
      setSearchBloster(value);
      dispatch(resetBlosterList());
      dispatch(fetchBlosterList({ page: 1, pagesize: 100, search: value }));
    } else {
      setSearchBloster('');
      dispatch(resetBlosterList());
      dispatch(resetCurrentBlosterPage());
      dispatch(fetchBlosterList({ page: 1, pagesize: 10 }));
    }
  };
  const handleChangeBloster = (value) => {
    setSearchBloster(value);
  };

  const onScrollDieSize = async (event) => {
    const target = event.target;
    if (!dieSizeLoading && dieSizeHasMore && target.scrollTop + target.offsetHeight === target.scrollHeight) {
      dispatch(fetchDieSizeList({ page: dieSizeCurrentPage, pagesize: 10 }));
    }
  };

  const onScrollDeveloper = async (event) => {
    const target = event.target;
    if (!developerLoading && developerHasMore && target.scrollTop + target.offsetHeight === target.scrollHeight) {
      dispatch(fetchVendorList({ page: developerCurrentPage, pagesize: 10 }));
    }
  };

  const onScrollBloster = async (event) => {
    const target = event.target;
    if (!blosterLoading && blosterHasMore && target.scrollTop + target.offsetHeight === target.scrollHeight) {
      dispatch(fetchBlosterList({ page: blosterCurrentPage, pagesize: 10 }));
    }
  };
  const handleSearchDiePress = value => {
    setSearchDiePress(value);
    if (value) {
      setSearchDiePress(value);
      dispatch(resetDiePressList());
      dispatch(fetchDiePressList({ page: 1, pagesize: 10, search: value }));
    } else {
      setSearchDiePress('');
      dispatch(resetDiePressList());
      dispatch(resetCurrentDiePressPage());
      dispatch(fetchDiePressList({ page: 1, pagesize: 10 }));
    }
  };

  const handleChangeDiePress = (value) => {
    setSearchDiePress(value);
  };

  useEffect(() => {
    dispatch(resetDieProfileList());
    dispatch(resetDieSizeList());
    dispatch(resetDiePressList());
    dispatch(resetVendorList());
    dispatch(resetBlosterList());
    dispatch(fetchDieSizeList({ page: 1, pagesize: 1000 }));
    dispatch(fetchVendorList({ page: 1, pagesize: 1000 }));
    dispatch(fetchBlosterList({ page: 1, pagesize: 1000 }));
    dispatch(fetchDiePressList({ page: 1, pagesize: 1000 }));
  }, [dieType]);

   const viewEntry = () => {
    navigate(`/view-dieprofile/${id}`);
  };

  const handleFinish = (values) => {
    setBtnLoading(true);
    const formattedValues = {
      ...values,
      order_date: values.order_date.format('YYYY-MM-DD'),
      received_date: values.received_date ? values.received_date.format('YYYY-MM-DD') : null,
    };
    values = formattedValues;
    values.die = id;
    values.deleted = 0;
    dispatch(createProfileDieTool({ values }))
      .unwrap()
      .then((result) => {
        setBtnLoading(false);
        if (result.success) {
          message.success('Die Tool Created Successfully!');
          setProfileResponse(result?.data?.id);
          form.resetFields();
        }
      })
      .catch((error) => {
        setBtnLoading(false);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error);
        } else if (error instanceof Error) {
          message.error(error.message);
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };

  const handleFieldChange = () => {
    const rackNo = form.getFieldValue('rac_no') || '';
    const rowNo = form.getFieldValue('row_no') || '';
    const columnNo = form.getFieldValue('column_no') || '';

    const dieLocation = `${rackNo} / ${rowNo} / ${columnNo}`;

    form.setFieldsValue({ die_location: dieLocation });
  };
  return (
    <>
      <div className='sticyaction'>
        <Row className="pagenamerow mb-0" justify="space-between" align="middle">
          <Col>
            <h2 style={{ margin: 0 }}>Add New Die Tool</h2>
            <div className="bredcrumbwrp">
              <Link onClick={() => navigate(-1)} className="back">
                <Back /> BACK
              </Link>
              <Breadcrumb
                items={[
                  { title: <Link to="/die-tool">Die Tools</Link> },
                  { title: 'Add New Die Tool' },
                ]}
              />
            </div>
          </Col>
        </Row>
      </div>
      <div className="formwrapper">
        <Form layout="vertical" onValuesChange={handleFormChange} form={form} initialValues={{ is_active: false, run_under_deviation: 'under development', ownership: 'hepl' }} onFinish={handleFinish} autoComplete="off">
          <div className="formsection">
            <Row gutter={16}>
              <Col xs={12} sm={8} xl={6} xxl={3}>
                <Form.Item
                  label="Profile No"
                  name="die"
                  rules={[{ required: true, message: 'Please select a Profile No' }]}
                >
                  <Select
                    placeholder="Select Profile No"
                    style={{ width: '100%' }}
                    disabled
                    value={searchGroup}
                    onChange={setSearchGroup}
                  >

                    <Option key={dieProfileDropdown.id} value={dieProfileDropdown.id}>
                      {dieProfileDropdown.die_number}
                    </Option>

                  </Select>
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={3}>
                <Form.Item
                  label="Current Kg / Mtr"
                  name="current_kg"
                  rules={[
                    { required: true, message: 'Please enter tool number' },
                    {
                      pattern: /^\d*\.?\d*$/,
                      message: 'Please enter only digits & decimal.',
                    },
                    createNumberValidationRule({
                      allowNegative: false,
                      maxBeforeDecimal: 10, // Set max before decimal
                      maxAfterDecimal: 3, // Set max after decimal
                      allowDecimal: true,
                      allowZero: true,
                    }),
                  ]}
                >
                  <Input
                    placeholder="Current Kg / Mtr"
                    maxLength={15}
                  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={3}>
                <Form.Item
                  label="Tool Number"
                  name="tool_number"
                  rules={[
                    { required: true, message: 'Please enter tool number' },
                    {
                      pattern: /^[0-9]+$/,
                      message: 'Only digits are allowed',
                    },
                  ]}
                >
                  <Input placeholder="Enter Tool Number" disabled />
                </Form.Item>
              </Col>

              {dieType === "Hollow" && (

                <Col xs={12} sm={8} xl={6} xxl={3}>
                  <Form.Item
                    name="die_option"
                    label="Hollow Die Option"
                    rules={[
                      {
                        required: true,
                        message: 'Please select a hollow die option',
                      },
                    ]}
                  >
                    <Select
                      placeholder="Hollow Die Option"
                      onChange={handleHoolowOptionChange}
                      onSearch={handleSearchHollowDie}
                      showSearch={true}
                      value={selectHollowOption}
                      allowClear
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {[
                        ...new Map(
                          hollowOptions.map(item => [item.id, item]),
                        ).values(),
                      ].map((el, index) => (
                        <Option key={index} value={el.id}>
                          {el.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              )}
              {selectHollowOption === 'Die Plate' && (
                <Col xs={12} sm={8} xl={6} xxl={3}>
                  <Form.Item
                    name="backer_number"
                    label="Backer Number"
                  >
                    <Input placeholder="Backer Number"></Input>
                  </Form.Item>
                </Col>
              )}
              {selectHollowOption === 'Mandril' && (
                <>
                  <Col xs={12} sm={8} xl={6} xxl={3}>
                    <Form.Item
                      name="diameter"
                      label="Diameter"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter diameter',
                        },
                      ]}
                    >
                      <Input placeholder="Enter Diameter" />
                    </Form.Item>
                  </Col>
                  <Col xs={12} sm={6} xl={6} xxl={3}>
                    <Form.Item
                      name="thickness"
                      label="Thickness"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter thickness',
                        },
                      ]}
                    >
                      <Input placeholder="Enter Thickness" />
                    </Form.Item>
                  </Col>
                </>
              )}
              {dieType === "Semi Hollow" && (

                <Col xs={12} sm={8} xl={6} xxl={3}>
                  <Form.Item
                    name="die_option"
                    label="Semi Hollow Die Option"
                    rules={[
                      {
                        required: true,
                        message: 'Please select a semi hollow die option',
                      },
                    ]}
                  >
                    <Select
                      placeholder="Semi Hollow Die Option"
                      onChange={handleSemiHoolowOptionChange}
                      onSearch={handleSearchHSemiHollowDie}
                      showSearch={true}
                      value={selectSemiHollowOption}
                      allowClear
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {[
                        ...new Map(
                          semiHollowOptions.map(item => [item.id, item]),
                        ).values(),
                      ].map((el, index) => (
                        <Option key={el.id} value={el.id}>
                          {el.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              )}
              {selectSemiHollowOption === 'Die Plate' && (
                <Col xs={12} sm={8} xl={6} xxl={3}>
                  <Form.Item
                    name="backer_number"
                    label="Backer Number"
                    rules={[
                      {
                        pattern: /^[a-zA-Z0-9]*$/,
                        message: 'Only alphanumeric characters are allowed.',
                      },
                    ]}
                  >
                    <Input placeholder="Backer Number"></Input>
                  </Form.Item>
                </Col>
              )}
              {selectSemiHollowOption === 'Mandril' && (
                <>
                  <Col xs={12} sm={8} xl={6} xxl={3}>
                    <Form.Item
                      name="diameter"
                      label="Diameter"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter diameter',
                        },
                      ]}
                    >
                      <Input placeholder="Enter Diameter" />
                    </Form.Item>
                  </Col>
                  <Col xs={12} sm={8} xl={6} xxl={3}>
                    <Form.Item
                      name="thickness"
                      label="Thickness"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter thickness',
                        },
                      ]}
                    >
                      <Input placeholder="Enter Thickness" />
                    </Form.Item>
                  </Col>
                </>
              )}
              {dieType === "Solid" && (
                <Col xs={12} sm={8} xl={6} xxl={3}>
                  <Form.Item
                    name="die_option"
                    label="Solid Die Option"
                    rules={[
                      {
                        required: true,
                        message: 'Please select a solid die option',
                      },
                    ]}
                  >
                    <Select
                      placeholder="Solid Die Option"
                      onChange={handleSolidOptionChange}
                      onSearch={handleSearchSolidDie}
                      showSearch={true}
                      value={selectedSolidOption}
                      allowClear
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {[
                        ...new Map(
                          solidOptions.map(item => [item.id, item]),
                        ).values(),
                      ].map((el, index) => (
                        <Option key={index} value={el.id}>
                          {el.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              )}
              {selectedSolidOption === 'Die Plate' && (
                <Col xs={12} sm={8} xl={6} xxl={3}>
                  <Form.Item
                    name="backer_number"
                    label="Backer Number"
                    rules={[
                      {
                        pattern: /^[a-zA-Z0-9]*$/,
                        message: 'Only alphanumeric characters are allowed.',
                      },
                    ]}
                  >
                    <Input placeholder="Backer Number"></Input>
                  </Form.Item>
                </Col>
              )}

              {selectedSolidOption === 'Insert' && (
                <>
                  <Col xs={12} sm={8} xl={6} xxl={3}>
                    <Form.Item
                      name="diameter"
                      label="Diameter"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter diameter',
                        },
                      ]}
                    >
                      <Input placeholder="Enter Diameter" />
                    </Form.Item>
                  </Col>
                  <Col xs={12} sm={8} xl={6} xxl={3}>
                    <Form.Item
                      name="thickness"
                      label="Thickness"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter thickness',
                        },
                      ]}
                    >
                      <Input placeholder="Enter Thickness" />
                    </Form.Item>
                  </Col>
                </>
              )}


              <Col xs={12} sm={8} xl={6} xxl={3}>
                <Form.Item
                  label="Die Size (MM)"
                  name="die_size"
                  rules={[{ required: true, message: 'Please select die size' }]}
                >
                  <Select placeholder="Select Die Size"
                    style={{ width: '100%' }}
                    loading={dieSizeLoading}
                    onPopupScroll={onScrollDieSize}
                    notFoundContent={dieSizeLoading ? "Loading..." : "No options"}
                    showSearch={true}
                    value={searchDieSize}
                    onChange={handleChangeDieSize}
                    onSearch={handleSearchDieSize}
                    dropdownRender={(menu) => (
                      <>
                        {menu}
                      </>
                    )}
                    allowClear
                    filterOption={(input, option) => {
                      if (!input) return true;

                      const optionText = (option?.children || '').toString().replace(/\s+/g, '').toLowerCase();
                      const inputText = input.replace(/\s+/g, '').toLowerCase();

                      return optionText.includes(inputText);
                    }}
                  >
                    {[...new Map(dieSizeList.map(item => [item.id, item])).values()].map((el, index) => (
                      <Option key={index} value={el.id}>
                        {el.die_width} X {el.die_height}
                      </Option>
                    ))}
                    {dieSizeLoading && <Option>Loading...</Option>}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={3}>
                <Form.Item
                  label="Die Cavity"
                  name="die_cavity"
                  rules={[
                    { required: true, message: 'Please enter die cavity' },
                    {
                      validator: (_, value) => {
                        if (!value || parseInt(value, 10) <= 10) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("Ensure this value is less than or equal to 10."));
                      },
                    },
                  ]}
                >
                  <Input placeholder="Enter Die Cavity"
                    onChange={e => {
                      const value = e.target.value;
                      const formattedValue = value
                        .toLowerCase()
                        .replace(/\b\w/g, char => char.toUpperCase());
                      form.setFieldsValue({ die_cavity: formattedValue }); // Update Form state
                    }} />
                </Form.Item>
              </Col>

              <Col xs={12} sm={8} xl={6} xxl={3}>
                <Form.Item name="eligible_for_press" label="Eligible For Press">
                  <Select
                    placeholder="Select Press"
                    loading={diePressLoading}
                    onPopupScroll={onScrollDiePress}
                    notFoundContent={
                      diePressLoading ? 'Loading...' : 'No options'
                    }
                    value={searchDiePress}
                    showSearch={true}
                    onSearch={handleSearchDiePress}
                    onChange={handleChangeDiePress}
                    allowClear
                    filterOption={(input, option) =>
                      option.children.toLowerCase().includes(input.toLowerCase())
                    }
                    dropdownRender={menu => (
                      <>
                        {menu}
                      </>
                    )}
                  >
                    {diePressList.map((el, idx) => (
                      <Option key={idx} value={el.id}>
                        {el.name}
                      </Option>
                    ))}
                    {diePressLoading && <Option>Loading...</Option>}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={3}>
                <Form.Item
                  label="Rack No"
                  name="rac_no"
                  rules={[
                    { required: true, message: 'Please enter rack number' },
                    {
                      pattern: /^[0-9]+(\.[0-9]*)?$/,
                      message: 'Only numeric values are allowed',
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter Rack Number"
                    onChange={handleFieldChange}
                    maxLength={10}
                  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={3}>
                <Form.Item
                  label="Row No"
                  name="row_no"
                  rules={[
                    { required: true, message: 'Please enter row no.' },
                    {
                      pattern: /^[A-Z]+$/,
                      message: 'Only uppercase & alphabets are allowed',
                    },
                  ]}

                >
                  <Input
                    placeholder="Enter Raw Number"
                    onChange={handleFieldChange}
                    maxLength={30}
                  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={3}>
                <Form.Item
                  label="Column No"
                  name="column_no"
                  rules={[
                    { required: true, message: 'Please enter column number' },
                    {
                      pattern: /^[0-9]+(\.[0-9]*)?$/,
                      message: 'Only numeric values are allowed',
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter Column No."
                    onChange={handleFieldChange}
                    maxLength={15}
                  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={3}>
                <Form.Item
                  label="Die Location"
                  name="die_location"
                  rules={[
                    { required: false, message: 'Please enter die location' },
                  ]}
                >
                  <Input placeholder="Enter Die Location" disabled />
                </Form.Item>
              </Col>
            </Row>
          </div>
          <div className="formsection">
            <Row gutter={16}>
              <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item
                  label="Vendor"
                  name="developer"
                  rules={[{ required: true, message: 'Please select developer' }]}
                >
                  <Select placeholder="Select Vendor Name"
                    style={{ width: '100%' }}
                    loading={developerLoading}
                    onPopupScroll={onScrollDeveloper}
                    notFoundContent={developerLoading ? "Loading..." : "No options"}
                    value={searchDeveloper}
                    showSearch={true}
                    onSearch={handleSearchDeveloper}
                    onChange={handleChangeDeveloper}
                    allowClear
                    filterOption={(input, option) =>
                      option.children.toLowerCase().includes(input.toLowerCase())
                    }
                    dropdownRender={(menu) => (
                      <>
                        {menu}
                      </>
                    )}
                  >
                    {[
                      ...new Map(
                        developerList.map(item => [item.id, item]),
                      ).values(),
                    ].map((el, index) => (
                      <Option key={index} value={el.id}>
                        {el.vendor_trade_name}
                      </Option>
                    ))}
                    {developerLoading && <Option>Loading...</Option>}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item
                  label="Developer Ref. No "
                  name="developer_ref_no"
                  rules={[
                    {
                      required: true,
                      message: 'Please Enter Developer Reference Number',
                    },
                  ]}
                >
                  <Input
                    placeholder="Developer Ref. No."
                    maxLength={30}
                    onChange={e => {
                      const value = e.target.value;
                      const formattedValue = value
                        .toLowerCase()
                        .replace(/\b\w/g, char => char.toUpperCase());
                      form.setFieldsValue({ developer_ref_no: formattedValue });
                    }} />
                </Form.Item>
              </Col>

              <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item
                  name="order_date"
                  label="Order Date"
                  rules={[{ required: true, message: 'Please select order date' }]}
                >
                  <DatePicker
                    placeholder="Select Date"
                    format="DD-MM-YYYY"
                    showTime={false}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item
                  label={
                    <span>
                      Received Date&nbsp;
                      <Tooltip title="The die tool is automatically activated if you select this date. Otherwise it is inactive.">
                        <InfoCircleOutlined
                          style={{ color: '#123B66', cursor: 'pointer' }}
                        />
                      </Tooltip>
                    </span>
                  }
                  name="received_date"
                  rules={
                    isReceivedDateRequired
                      ? [
                        {
                          required: true,
                          message: 'Please select received date',
                        },
                      ]
                      : []
                  }
                >
                  <DatePicker
                    placeholder="Select Date"
                    format="DD-MM-YYYY"
                    showTime={false}
                    style={{ width: '100%' }}
                    onChange={handleReceivedDateChange}

                  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item name="total_running_qty" label="Total Running Kilometer"
                  rules={[
                    {
                      pattern: /^\d*\.?\d*$/,
                      message: 'Please enter only digits & decimal.',
                    }
                  ]}
                >
                  <Input placeholder="Enter Kilometer" disabled />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item name="total_running_ton" label="Total Running Metric Ton" colon={false}
                  rules={[
                    {
                      pattern: /^\d*\.?\d*$/,
                      message: 'Please enter only digits & decimal.',
                    }
                  ]}
                >
                  <Input placeholder="Enter Metric Ton" disabled />
                </Form.Item>
              </Col>


              <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item
                  label={
                    <span>
                      Drawing No.&nbsp;
                      <Tooltip title="Drawing No.">
                        <InfoCircleOutlined
                          style={{ color: '#123B66', cursor: 'pointer' }}
                        />
                      </Tooltip>
                    </span>
                  }
                  rules={[
                    {
                      pattern: /^[A-Za-z0-9 ]*$/,
                      required: true,
                      message: 'Only alphabets, numbers, and spaces are allowed',
                    },
                  ]}
                  name="drawing_no"
                >
                  <Input placeholder="Enter Drawing No."
                    onChange={e => {
                      const value = e.target.value;
                      const formattedValue = value
                        .toLowerCase()
                        .replace(/\b\w/g, char => char.toUpperCase());
                      form.setFieldsValue({ drawing_no: formattedValue });
                    }} />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item label="Purchase Price" name="purchase_price"
                  rules={[
                    {
                      pattern: /^\d{1,8}(\.\d{0,2})?$/,
                      message: 'Enter a valid price (up to 2 decimals).',
                    }
                  ]}
                >
                  <Input placeholder="Purchase Price" maxLength={10} />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={4}>
                <Form.Item
                  label="Die Received Status"
                  name="is_active"
                  valuePropName="checked"
                >
                  <Checkbox disabled={isCheckboxDisabled} >Is Active</Checkbox>
                </Form.Item>
              </Col>
            </Row>
          </div>
          <div className="formsection">
            <Row gutter={16}>
              <Col xs={24} sm={12} xl={8} xxl={3}>
                <Form.Item
                  label="Eligible Bolster"
                  name="eligible_bloster"
                >
                  <Select placeholder="Select Bolster"
                    style={{ width: '100%' }} loading={blosterLoading}
                    onPopupScroll={onScrollBloster}
                    notFoundContent={blosterLoading ? "Loading..." : "No options"}
                    value={searchBloster}
                    onChange={handleChangeBloster}
                    onSearch={handleSearchBloster}
                    showSearch={true}
                    allowClear
                    filterOption={(input, option) =>
                      option.children.toLowerCase().includes(input.toLowerCase())
                    }
                    dropdownRender={(menu) => (
                      <>
                        {menu}
                      </>
                    )}
                  >
                    {[
                      ...new Map(
                        blosterList.map(item => [item.id, item]),
                      ).values(),
                    ].map((el, index) => (
                      <Option key={index} value={el.id}>
                        {el.bloster_no}
                      </Option>
                    ))}
                    {blosterLoading && <Option>Loading...</Option>}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={12} sm={12} xl={6} xxl={6}>
                <Form.Item
                  label="Ownership"
                  name="ownership"
                  rules={[{ required: true, message: 'Please select an option' }]}
                >
                  <Radio.Group>
                    <Radio value="hepl">Hepl</Radio>
                    <Radio value="customer">Customer</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} xl={12} xxl={12}>
                <Form.Item
                  label="Run Under Deviation"
                  name="run_under_deviation"
                  rules={[{ required: true, message: 'Please select an option' }]}
                >
                  <Radio.Group onChange={handleDeviationChange} value={runUnderDeviation}>
                    <Radio value="active">Active</Radio>
                    <Radio value="inactive">Inactive</Radio>
                    <Radio value="under development">Under Development</Radio>

                  </Radio.Group>

                  {runUnderDeviation === 'inactive' && (
                    <div style={{ marginTop: '8px' }}>
                      <Form.Item
                        label="Reason"
                        name="run_under_deviation_inactive"
                        rules={[
                          { required: true, message: 'Please select a reason!' },
                        ]}
                      >
                        <Radio.Group
                          onChange={handleReasonChange}
                          value={runUnderDeviationReason}
                        >
                          <Radio value="die_broken">Die Broken</Radio>
                          <Radio value="die_absolute">Die Absolute</Radio>
                          <Radio value="die_shift">Die Shift</Radio>
                          <Radio value="other">Other</Radio>
                        </Radio.Group>
                      </Form.Item>
                      {runUnderDeviationReason === 'other' && (
                        <Form.Item
                          name="run_under_deviation_reason"
                          rules={[{ required: true, message: 'Please specify the reason' }]}
                        >
                          <Input
                            style={{ marginTop: '8px' }}
                            placeholder="Specify other reason"
                            onChange={(e) => {
                              const value = e.target.value;
                              const formattedValue = value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
                              form.setFieldsValue({ run_under_deviation_reason: formattedValue }); // Update Form state
                            }}
                          />
                        </Form.Item>
                      )}
                    </div>
                  )}
                </Form.Item>
              </Col>
            </Row>
          </div>

          <Form.Item label="Remarks" name="remarks">
            <Input.TextArea
              rows={4}
              placeholder="Write a remark, maximum 150 characters"
              maxLength={150}
              onChange={(e) => {
                const value = e.target.value;
                const formattedValue = value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
                form.setFieldsValue({ remarks: formattedValue }); // Update Form state
              }}
            />
          </Form.Item>
          <div className="flex justify-end">

            {profileResponse === null && (
              <>
                <Tooltip placement="top" title={'View Record'}>
                  <Button
                    type="primary"
                    style={{ marginRight: '15px' }}
                    htmlType="submit"
                    icon={<EyeOutlined />}
                    onClick={() => viewEntry()}
                  >
                    View Tool Entry
                  </Button>
                </Tooltip>
              </>
            )}

            {profileResponse === null && (
              <Form.Item className="mb-0">
                <Button type="primary" htmlType="submit" loading={btnLoading} icon={<PlusOutlined />}>
                  Add Tool
                </Button>
              </Form.Item>
            )}
            
          </div>

        </Form >
      </div>
    </>
  );
}

export default AddProfileDieTool;
